import { client } from "../client";
import { Material } from "../types/material.types";

export const createMaterial = async (material: Partial<Material>) => {
  const response = await client.post<Material>(`materials/`, {
    ...material,
  });
  return response.data;
};

export const updateMaterial = async ({id, ...material}: Partial<Material>) => {
  const response = await client.patch<Material>(`materials/${id}/`, {
    ...material,
  });
  return response.data;
};
